(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("core-js/modules/es.object.entries.js"), require("@splat/form"), require("@splat/form-item"), require("@splat/iconfont"), require("@splat/input"), require("@splat/select"), require("core-js/modules/esnext.global-this.js"), require("vuex"), require("vuex-class"), require("moment"), require("vue-property-decorator"), require("vue-tsx-support"));
	else if(typeof define === 'function' && define.amd)
		define(["core-js/modules/es.object.entries.js", , , , , , "core-js/modules/esnext.global-this.js", , , , , ], factory);
	else if(typeof exports === 'object')
		exports["verifier"] = factory(require("core-js/modules/es.object.entries.js"), require("@splat/form"), require("@splat/form-item"), require("@splat/iconfont"), require("@splat/input"), require("@splat/select"), require("core-js/modules/esnext.global-this.js"), require("vuex"), require("vuex-class"), require("moment"), require("vue-property-decorator"), require("vue-tsx-support"));
	else
		root["verifier"] = factory(root["core-js/modules/es.object.entries.js"], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root["core-js/modules/esnext.global-this.js"], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_core_js_modules_es_object_entries_js__, __WEBPACK_EXTERNAL_MODULE__splat_form__, __WEBPACK_EXTERNAL_MODULE__splat_form_item__, __WEBPACK_EXTERNAL_MODULE__splat_iconfont__, __WEBPACK_EXTERNAL_MODULE__splat_input__, __WEBPACK_EXTERNAL_MODULE__splat_select__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__, __WEBPACK_EXTERNAL_MODULE_vuex__, __WEBPACK_EXTERNAL_MODULE_vuex_class__, __WEBPACK_EXTERNAL_MODULE_moment__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__) {
return /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/gen/index.ts":
/*!**************************!*\
  !*** ./src/gen/index.ts ***!
  \**************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FilterType": function() { return /* binding */ FilterType; },
/* harmony export */   "BuiltinValidatorKind": function() { return /* binding */ BuiltinValidatorKind; },
/* harmony export */   "AccountAuthServiceBindCurrentUserOAuthCall": function() { return /* binding */ AccountAuthServiceBindCurrentUserOAuthCall; },
/* harmony export */   "AccountAuthServiceBindCurrentUserOAuthValidators": function() { return /* binding */ AccountAuthServiceBindCurrentUserOAuthValidators; },
/* harmony export */   "AccountAuthServiceConfirmCurrentUserTotpCall": function() { return /* binding */ AccountAuthServiceConfirmCurrentUserTotpCall; },
/* harmony export */   "AccountAuthServiceConfirmCurrentUserTotpValidators": function() { return /* binding */ AccountAuthServiceConfirmCurrentUserTotpValidators; },
/* harmony export */   "AccountAuthServiceCreateAPITokenCall": function() { return /* binding */ AccountAuthServiceCreateAPITokenCall; },
/* harmony export */   "AccountAuthServiceCreateAPITokenValidators": function() { return /* binding */ AccountAuthServiceCreateAPITokenValidators; },
/* harmony export */   "AccountAuthServiceCreateLoginTokenCall": function() { return /* binding */ AccountAuthServiceCreateLoginTokenCall; },
/* harmony export */   "AccountAuthServiceCreateLoginTokenValidators": function() { return /* binding */ AccountAuthServiceCreateLoginTokenValidators; },
/* harmony export */   "AccountAuthServiceCreateRoleCall": function() { return /* binding */ AccountAuthServiceCreateRoleCall; },
/* harmony export */   "AccountAuthServiceCreateRoleValidators": function() { return /* binding */ AccountAuthServiceCreateRoleValidators; },
/* harmony export */   "AccountAuthServiceCreateSessionTokenCall": function() { return /* binding */ AccountAuthServiceCreateSessionTokenCall; },
/* harmony export */   "AccountAuthServiceCreateSessionTokenValidators": function() { return /* binding */ AccountAuthServiceCreateSessionTokenValidators; },
/* harmony export */   "AccountAuthServiceCreateUserCall": function() { return /* binding */ AccountAuthServiceCreateUserCall; },
/* harmony export */   "AccountAuthServiceCreateUserValidators": function() { return /* binding */ AccountAuthServiceCreateUserValidators; },
/* harmony export */   "AccountAuthServiceDeleteAPITokenCall": function() { return /* binding */ AccountAuthServiceDeleteAPITokenCall; },
/* harmony export */   "AccountAuthServiceDeleteAPITokenValidators": function() { return /* binding */ AccountAuthServiceDeleteAPITokenValidators; },
/* harmony export */   "AccountAuthServiceDeleteCurrentUserTotpCall": function() { return /* binding */ AccountAuthServiceDeleteCurrentUserTotpCall; },
/* harmony export */   "AccountAuthServiceDeleteRoleCall": function() { return /* binding */ AccountAuthServiceDeleteRoleCall; },
/* harmony export */   "AccountAuthServiceDeleteRoleValidators": function() { return /* binding */ AccountAuthServiceDeleteRoleValidators; },
/* harmony export */   "AccountAuthServiceDeleteUserCall": function() { return /* binding */ AccountAuthServiceDeleteUserCall; },
/* harmony export */   "AccountAuthServiceEditAPITokenCall": function() { return /* binding */ AccountAuthServiceEditAPITokenCall; },
/* harmony export */   "AccountAuthServiceEditAPITokenValidators": function() { return /* binding */ AccountAuthServiceEditAPITokenValidators; },
/* harmony export */   "AccountAuthServiceEditAPITokenEnableCall": function() { return /* binding */ AccountAuthServiceEditAPITokenEnableCall; },
/* harmony export */   "AccountAuthServiceEditAPITokenEnableValidators": function() { return /* binding */ AccountAuthServiceEditAPITokenEnableValidators; },
/* harmony export */   "AccountAuthServiceEditCurrentUserCredentialCall": function() { return /* binding */ AccountAuthServiceEditCurrentUserCredentialCall; },
/* harmony export */   "AccountAuthServiceEditCurrentUserCredentialValidators": function() { return /* binding */ AccountAuthServiceEditCurrentUserCredentialValidators; },
/* harmony export */   "AccountAuthServiceEditCurrentUserInfoCall": function() { return /* binding */ AccountAuthServiceEditCurrentUserInfoCall; },
/* harmony export */   "AccountAuthServiceEditCurrentUserInfoValidators": function() { return /* binding */ AccountAuthServiceEditCurrentUserInfoValidators; },
/* harmony export */   "AccountAuthServiceEditCurrentUserIPPolicyCall": function() { return /* binding */ AccountAuthServiceEditCurrentUserIPPolicyCall; },
/* harmony export */   "AccountAuthServiceEditCurrentUserIPPolicyValidators": function() { return /* binding */ AccountAuthServiceEditCurrentUserIPPolicyValidators; },
/* harmony export */   "AccountAuthServiceEditCurrentUserLanguageCall": function() { return /* binding */ AccountAuthServiceEditCurrentUserLanguageCall; },
/* harmony export */   "AccountAuthServiceEditCurrentUserLanguageValidators": function() { return /* binding */ AccountAuthServiceEditCurrentUserLanguageValidators; },
/* harmony export */   "AccountAuthServiceEditCurrentUserNameCall": function() { return /* binding */ AccountAuthServiceEditCurrentUserNameCall; },
/* harmony export */   "AccountAuthServiceEditCurrentUserNameValidators": function() { return /* binding */ AccountAuthServiceEditCurrentUserNameValidators; },
/* harmony export */   "AccountAuthServiceEditCurrentUserSessionExpireTimeCall": function() { return /* binding */ AccountAuthServiceEditCurrentUserSessionExpireTimeCall; },
/* harmony export */   "AccountAuthServiceEditCurrentUserSessionExpireTimeValidators": function() { return /* binding */ AccountAuthServiceEditCurrentUserSessionExpireTimeValidators; },
/* harmony export */   "AccountAuthServiceEditCurrentUserTimezoneCall": function() { return /* binding */ AccountAuthServiceEditCurrentUserTimezoneCall; },
/* harmony export */   "AccountAuthServiceEditCurrentUserTimezoneValidators": function() { return /* binding */ AccountAuthServiceEditCurrentUserTimezoneValidators; },
/* harmony export */   "AccountAuthServiceEditRoleCall": function() { return /* binding */ AccountAuthServiceEditRoleCall; },
/* harmony export */   "AccountAuthServiceEditRoleValidators": function() { return /* binding */ AccountAuthServiceEditRoleValidators; },
/* harmony export */   "AccountAuthServiceEditUserCall": function() { return /* binding */ AccountAuthServiceEditUserCall; },
/* harmony export */   "AccountAuthServiceEditUserValidators": function() { return /* binding */ AccountAuthServiceEditUserValidators; },
/* harmony export */   "AccountAuthServiceEditUserCredentialCall": function() { return /* binding */ AccountAuthServiceEditUserCredentialCall; },
/* harmony export */   "AccountAuthServiceEditUserCredentialValidators": function() { return /* binding */ AccountAuthServiceEditUserCredentialValidators; },
/* harmony export */   "AccountAuthServiceEditUserEnableCall": function() { return /* binding */ AccountAuthServiceEditUserEnableCall; },
/* harmony export */   "AccountAuthServiceEditUserEnableValidators": function() { return /* binding */ AccountAuthServiceEditUserEnableValidators; },
/* harmony export */   "AccountAuthServiceEditUserExpireTimeCall": function() { return /* binding */ AccountAuthServiceEditUserExpireTimeCall; },
/* harmony export */   "AccountAuthServiceEditUserExpireTimeValidators": function() { return /* binding */ AccountAuthServiceEditUserExpireTimeValidators; },
/* harmony export */   "AccountAuthServiceEditUserInfoCall": function() { return /* binding */ AccountAuthServiceEditUserInfoCall; },
/* harmony export */   "AccountAuthServiceEditUserInfoValidators": function() { return /* binding */ AccountAuthServiceEditUserInfoValidators; },
/* harmony export */   "AccountAuthServiceEditUserIPPolicyCall": function() { return /* binding */ AccountAuthServiceEditUserIPPolicyCall; },
/* harmony export */   "AccountAuthServiceEditUserIPPolicyValidators": function() { return /* binding */ AccountAuthServiceEditUserIPPolicyValidators; },
/* harmony export */   "AccountAuthServiceEditUserNameCall": function() { return /* binding */ AccountAuthServiceEditUserNameCall; },
/* harmony export */   "AccountAuthServiceEditUserNameValidators": function() { return /* binding */ AccountAuthServiceEditUserNameValidators; },
/* harmony export */   "AccountAuthServiceEditUserRoleCall": function() { return /* binding */ AccountAuthServiceEditUserRoleCall; },
/* harmony export */   "AccountAuthServiceEditUserRoleValidators": function() { return /* binding */ AccountAuthServiceEditUserRoleValidators; },
/* harmony export */   "AccountAuthServiceEditUserSessionExpireTimeCall": function() { return /* binding */ AccountAuthServiceEditUserSessionExpireTimeCall; },
/* harmony export */   "AccountAuthServiceEditUserSessionExpireTimeValidators": function() { return /* binding */ AccountAuthServiceEditUserSessionExpireTimeValidators; },
/* harmony export */   "AccountAuthServiceGenerateTotpCall": function() { return /* binding */ AccountAuthServiceGenerateTotpCall; },
/* harmony export */   "AccountAuthServiceGetAPITokenCall": function() { return /* binding */ AccountAuthServiceGetAPITokenCall; },
/* harmony export */   "makeAccountAuthServiceGetAPITokenFilterOptions": function() { return /* binding */ makeAccountAuthServiceGetAPITokenFilterOptions; },
/* harmony export */   "AccountNoAuthServiceGetAvailableOAuthCall": function() { return /* binding */ AccountNoAuthServiceGetAvailableOAuthCall; },
/* harmony export */   "AccountAuthServiceGetCurrentUserInfoCall": function() { return /* binding */ AccountAuthServiceGetCurrentUserInfoCall; },
/* harmony export */   "AccountAuthServiceGetCurrentUserOAuthBindCall": function() { return /* binding */ AccountAuthServiceGetCurrentUserOAuthBindCall; },
/* harmony export */   "AccountAuthServiceGetCurrentUserPermissionCall": function() { return /* binding */ AccountAuthServiceGetCurrentUserPermissionCall; },
/* harmony export */   "AccountAuthServiceGetPermissionInfoCall": function() { return /* binding */ AccountAuthServiceGetPermissionInfoCall; },
/* harmony export */   "AccountAuthServiceGetRoleInfoCall": function() { return /* binding */ AccountAuthServiceGetRoleInfoCall; },
/* harmony export */   "AccountAuthServiceGetRoleInfoValidators": function() { return /* binding */ AccountAuthServiceGetRoleInfoValidators; },
/* harmony export */   "AccountAuthServiceGetRoleListCall": function() { return /* binding */ AccountAuthServiceGetRoleListCall; },
/* harmony export */   "makeAccountAuthServiceGetRoleListFilterOptions": function() { return /* binding */ makeAccountAuthServiceGetRoleListFilterOptions; },
/* harmony export */   "AccountAuthServiceGetSessionTokenExpireCall": function() { return /* binding */ AccountAuthServiceGetSessionTokenExpireCall; },
/* harmony export */   "AccountAuthServiceGetUserInfoCall": function() { return /* binding */ AccountAuthServiceGetUserInfoCall; },
/* harmony export */   "AccountAuthServiceGetUserInfoValidators": function() { return /* binding */ AccountAuthServiceGetUserInfoValidators; },
/* harmony export */   "AccountAuthServiceGetUserListCall": function() { return /* binding */ AccountAuthServiceGetUserListCall; },
/* harmony export */   "makeAccountAuthServiceGetUserListFilterOptions": function() { return /* binding */ makeAccountAuthServiceGetUserListFilterOptions; },
/* harmony export */   "AccountNoAuthServiceLoginCall": function() { return /* binding */ AccountNoAuthServiceLoginCall; },
/* harmony export */   "AccountNoAuthServiceLoginValidators": function() { return /* binding */ AccountNoAuthServiceLoginValidators; },
/* harmony export */   "AccountNoAuthServiceLoginAsCall": function() { return /* binding */ AccountNoAuthServiceLoginAsCall; },
/* harmony export */   "AccountNoAuthServiceLoginAsValidators": function() { return /* binding */ AccountNoAuthServiceLoginAsValidators; },
/* harmony export */   "AccountAuthServiceLogoutCall": function() { return /* binding */ AccountAuthServiceLogoutCall; },
/* harmony export */   "AccountNoAuthServiceMfaCall": function() { return /* binding */ AccountNoAuthServiceMfaCall; },
/* harmony export */   "AccountNoAuthServiceMfaValidators": function() { return /* binding */ AccountNoAuthServiceMfaValidators; },
/* harmony export */   "AccountAuthServicePingCall": function() { return /* binding */ AccountAuthServicePingCall; },
/* harmony export */   "AccountAuthServicePingValidators": function() { return /* binding */ AccountAuthServicePingValidators; },
/* harmony export */   "AccountAuthServiceUnbindCurrentUserOAuthCall": function() { return /* binding */ AccountAuthServiceUnbindCurrentUserOAuthCall; },
/* harmony export */   "AccountAuthServiceUnbindCurrentUserOAuthValidators": function() { return /* binding */ AccountAuthServiceUnbindCurrentUserOAuthValidators; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");


/**
 * @internal */
var FilterType;

(function (FilterType) {
  FilterType["text"] = "text";
  FilterType["bool"] = "bool";
  FilterType["number"] = "number";
  FilterType["number_range"] = "number_range";
  FilterType["choice"] = "choice";
  FilterType["time_range"] = "time_range";
  FilterType["filterable_choice"] = "filterable_choice";
})(FilterType || (FilterType = {}));

var BuiltinValidatorKind;

(function (BuiltinValidatorKind) {
  BuiltinValidatorKind["required"] = "required";
})(BuiltinValidatorKind || (BuiltinValidatorKind = {}));
/**
 * @internal
 * BindCurrentUserOAuth bind oauth account */


function AccountAuthServiceBindCurrentUserOAuthCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.BindCurrentUserOAuth', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceBindCurrentUserOAuthValidators = {
  type: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * ConfirmCurrentUserTotp change user credential */

function AccountAuthServiceConfirmCurrentUserTotpCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.ConfirmCurrentUserTotp', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceConfirmCurrentUserTotpValidators = {
  secret: [{
    type: BuiltinValidatorKind.required
  }],
  totp: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * CreateAPIToken edit api token */

function AccountAuthServiceCreateAPITokenCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.CreateAPIToken', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceCreateAPITokenValidators = {
  can_login: [{
    type: BuiltinValidatorKind.required
  }],
  expire_time: [{
    type: BuiltinValidatorKind.required
  }],
  ip_policy: [{
    type: BuiltinValidatorKind.required
  }],
  name: [{
    type: BuiltinValidatorKind.required
  }],
  remark: [{
    type: BuiltinValidatorKind.required
  }],
  roles: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * CreateLoginToken create login token */

function AccountAuthServiceCreateLoginTokenCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.CreateLoginToken', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceCreateLoginTokenValidators = {
  api_token: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * CreateRole create role */

function AccountAuthServiceCreateRoleCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.CreateRole', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceCreateRoleValidators = {
  description: [{
    type: BuiltinValidatorKind.required
  }],
  name: [{
    type: BuiltinValidatorKind.required
  }],
  permissions: [{
    type: BuiltinValidatorKind.required
  }],
  user_ids: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * CreateSessionToken create session token */

function AccountAuthServiceCreateSessionTokenCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.CreateSessionToken', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceCreateSessionTokenValidators = {
  duration: [{
    type: BuiltinValidatorKind.required
  }],
  permissions: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * CreateUser create user and return default random password */

function AccountAuthServiceCreateUserCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.CreateUser', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceCreateUserValidators = {
  expire_time: [{
    type: BuiltinValidatorKind.required
  }],
  ip_policy: [{
    type: BuiltinValidatorKind.required
  }],
  is_enabled: [{
    type: BuiltinValidatorKind.required
  }],
  remark: [{
    type: BuiltinValidatorKind.required
  }],
  roles: [{
    type: BuiltinValidatorKind.required
  }],
  username: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * DeleteAPIToken delete api token searched by ids */

function AccountAuthServiceDeleteAPITokenCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.DeleteAPIToken', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceDeleteAPITokenValidators = {
  ids: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * DeleteCurrentUserTotp change user credential */

function AccountAuthServiceDeleteCurrentUserTotpCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.DeleteCurrentUserTotp', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal
 * DeleteRole delete role */

function AccountAuthServiceDeleteRoleCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.DeleteRole', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceDeleteRoleValidators = {
  ids: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * DeleteUser delete user */

function AccountAuthServiceDeleteUserCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.DeleteUser', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal
 * EditAPIToken edit token searchec by ID */

function AccountAuthServiceEditAPITokenCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditAPIToken', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditAPITokenValidators = {
  can_login: [{
    type: BuiltinValidatorKind.required
  }],
  expire_time: [{
    type: BuiltinValidatorKind.required
  }],
  id: [{
    type: BuiltinValidatorKind.required
  }],
  ip_policy: [{
    type: BuiltinValidatorKind.required
  }],
  name: [{
    type: BuiltinValidatorKind.required
  }],
  remark: [{
    type: BuiltinValidatorKind.required
  }],
  roles: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditAPITokenEnable modify api token IsEnabled */

function AccountAuthServiceEditAPITokenEnableCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditAPITokenEnable', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditAPITokenEnableValidators = {
  ids: [{
    type: BuiltinValidatorKind.required
  }],
  is_enabled: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditCurrentUserCredential change user credential */

function AccountAuthServiceEditCurrentUserCredentialCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditCurrentUserCredential', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditCurrentUserCredentialValidators = {
  dup_pwd: [{
    type: BuiltinValidatorKind.required
  }],
  new_pwd: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditCurrentUserInfo set user info */

function AccountAuthServiceEditCurrentUserInfoCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditCurrentUserInfo', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditCurrentUserInfoValidators = {
  remark: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditCurrentUserIPPolicy change user's permission */

function AccountAuthServiceEditCurrentUserIPPolicyCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditCurrentUserIPPolicy', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditCurrentUserIPPolicyValidators = {
  ip_policy_enabled: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditCurrentUserLanguage change user language */

function AccountAuthServiceEditCurrentUserLanguageCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditCurrentUserLanguage', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditCurrentUserLanguageValidators = {
  lang: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditCurrentUserName change user credential */

function AccountAuthServiceEditCurrentUserNameCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditCurrentUserName', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditCurrentUserNameValidators = {
  username: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditCurrentUserSessionExpireTime change user's session expire time */

function AccountAuthServiceEditCurrentUserSessionExpireTimeCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditCurrentUserSessionExpireTime', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditCurrentUserSessionExpireTimeValidators = {
  session_expire_time: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditCurrentUserTimezone change user timezone */

function AccountAuthServiceEditCurrentUserTimezoneCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditCurrentUserTimezone', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditCurrentUserTimezoneValidators = {
  timezone: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditRole create role */

function AccountAuthServiceEditRoleCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditRole', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditRoleValidators = {
  description: [{
    type: BuiltinValidatorKind.required
  }],
  id: [{
    type: BuiltinValidatorKind.required
  }],
  name: [{
    type: BuiltinValidatorKind.required
  }],
  permissions: [{
    type: BuiltinValidatorKind.required
  }],
  user_ids: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditUser edit user */

function AccountAuthServiceEditUserCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditUser', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditUserValidators = {
  expire_time: [{
    type: BuiltinValidatorKind.required
  }],
  id: [{
    type: BuiltinValidatorKind.required
  }],
  is_enabled: [{
    type: BuiltinValidatorKind.required
  }],
  remark: [{
    type: BuiltinValidatorKind.required
  }],
  roles: [{
    type: BuiltinValidatorKind.required
  }],
  username: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditUserCredential edit user credential */

function AccountAuthServiceEditUserCredentialCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditUserCredential', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditUserCredentialValidators = {
  id: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditUserEnable modify user IsEnabled */

function AccountAuthServiceEditUserEnableCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditUserEnable', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditUserEnableValidators = {
  is_enabled: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditUserExpireTime change user credential */

function AccountAuthServiceEditUserExpireTimeCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditUserExpireTime', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditUserExpireTimeValidators = {
  expire_time: [{
    type: BuiltinValidatorKind.required
  }],
  id: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditUserInfo edit user info */

function AccountAuthServiceEditUserInfoCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditUserInfo', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditUserInfoValidators = {
  id: [{
    type: BuiltinValidatorKind.required
  }],
  remark: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditUserIPPolicy edit user ip policy */

function AccountAuthServiceEditUserIPPolicyCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditUserIPPolicy', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditUserIPPolicyValidators = {
  id: [{
    type: BuiltinValidatorKind.required
  }],
  ip_policy_enabled: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditUserName change user credential */

function AccountAuthServiceEditUserNameCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditUserName', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditUserNameValidators = {
  id: [{
    type: BuiltinValidatorKind.required
  }],
  username: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditUserRole edit user permission */

function AccountAuthServiceEditUserRoleCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditUserRole', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditUserRoleValidators = {
  id: [{
    type: BuiltinValidatorKind.required
  }],
  roles: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * EditUserSessionExpireTime edit user session expire time */

function AccountAuthServiceEditUserSessionExpireTimeCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.EditUserSessionExpireTime', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceEditUserSessionExpireTimeValidators = {
  id: [{
    type: BuiltinValidatorKind.required
  }],
  session_expire_time: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * GenerateTotp change user credential */

function AccountAuthServiceGenerateTotpCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.GenerateTotp', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal
 * GetAPIToken return api token searched by args */

function AccountAuthServiceGetAPITokenCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.GetAPIToken', params, options, cancelToken, headers);
  return resp;
}
function makeAccountAuthServiceGetAPITokenFilterOptions(route, translationMap) {
  return {
    filter: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, route.name, [{
      type: FilterType.time_range,
      key: 'expire_time',
      translation: translationMap.get('expire_time')
    }, {
      type: FilterType.text,
      key: 'remark',
      translation: translationMap.get('remark')
    }, {
      type: FilterType.text,
      key: 'status',
      translation: translationMap.get('status')
    }]),
    route: route
  };
}
/**
 * @internal
 * GetAvailableOAuth names and its translation */

function AccountNoAuthServiceGetAvailableOAuthCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountNoAuthService.GetAvailableOAuth', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal
 * GetCurrentUserInfo return current user info */

function AccountAuthServiceGetCurrentUserInfoCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.GetCurrentUserInfo', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal
 * GetCurrentUserOAuthBind return current user info */

function AccountAuthServiceGetCurrentUserOAuthBindCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.GetCurrentUserOAuthBind', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal
 * GetCurrentUserInfo return current user info */

function AccountAuthServiceGetCurrentUserPermissionCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.GetCurrentUserPermission', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal
 * GetPermissionInfo return tag name map */

function AccountAuthServiceGetPermissionInfoCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.GetPermissionInfo', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal
 * GetRoleInfo return basic info of the role searched by id */

function AccountAuthServiceGetRoleInfoCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.GetRoleInfo', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceGetRoleInfoValidators = {
  id: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * GetRoleList return role basic info list searched by condition */

function AccountAuthServiceGetRoleListCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.GetRoleList', params, options, cancelToken, headers);
  return resp;
}
function makeAccountAuthServiceGetRoleListFilterOptions(route, translationMap) {
  return {
    filter: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, route.name, [{
      type: FilterType.time_range,
      key: 'create_at',
      translation: translationMap.get('create_at')
    }, {
      type: FilterType.text,
      key: 'description',
      translation: translationMap.get('description')
    }, {
      type: FilterType.text,
      key: 'username',
      translation: translationMap.get('username')
    }]),
    route: route
  };
}
/**
 * @internal
 * GetSessionTokenExpire get session token expire time */

function AccountAuthServiceGetSessionTokenExpireCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.GetSessionTokenExpire', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal
 * GetUserInfo return basic info of the user searched by id */

function AccountAuthServiceGetUserInfoCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.GetUserInfo', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceGetUserInfoValidators = {
  id: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * GetUserList return user basic info list searched by condition */

function AccountAuthServiceGetUserListCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.GetUserList', params, options, cancelToken, headers);
  return resp;
}
function makeAccountAuthServiceGetUserListFilterOptions(route, translationMap) {
  return {
    filter: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, route.name, [{
      type: FilterType.time_range,
      key: 'create_at',
      translation: translationMap.get('create_at')
    }, {
      type: FilterType.bool,
      key: 'is_enabled',
      translation: translationMap.get('is_enabled')
    }, {
      type: FilterType.time_range,
      key: 'last_login',
      translation: translationMap.get('last_login')
    }, {
      type: FilterType.text,
      key: 'remark',
      translation: translationMap.get('remark')
    }, {
      type: FilterType.text,
      key: 'role',
      translation: translationMap.get('role')
    }]),
    route: route
  };
}
/**
 * @internal
 * Login authorizes user's Login */

function AccountNoAuthServiceLoginCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountNoAuthService.Login', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountNoAuthServiceLoginValidators = {
  username: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * LoginAs is a dev mode api for debug purpose only */

function AccountNoAuthServiceLoginAsCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountNoAuthService.LoginAs', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountNoAuthServiceLoginAsValidators = {
  password: [{
    type: BuiltinValidatorKind.required
  }],
  username: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * Logout is api for user logout */

function AccountAuthServiceLogoutCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.Logout', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal
 * Mfa authorizes user's MFA */

function AccountNoAuthServiceMfaCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountNoAuthService.Mfa', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountNoAuthServiceMfaValidators = {
  username: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * Ping is api to ping */

function AccountAuthServicePingCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.Ping', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServicePingValidators = {
  data: [{
    type: BuiltinValidatorKind.required
  }]
};
/**
 * @internal
 * GetCurrentUserInfo return current user info */

function AccountAuthServiceUnbindCurrentUserOAuthCall(client, params, cancelToken, headers, options) {
  var resp = client.request('AccountAuthService.UnbindCurrentUserOAuth', params, options, cancelToken, headers);
  return resp;
}
/**
 * @internal */

var AccountAuthServiceUnbindCurrentUserOAuthValidators = {
  type: [{
    type: BuiltinValidatorKind.required
  }]
};

/***/ }),

/***/ "./src/locales/index.ts":
/*!******************************!*\
  !*** ./src/locales/index.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I18nProvider": function() { return /* binding */ I18nProvider; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/esnext.global-this.js */ "core-js/modules/esnext.global-this.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__);




var I18nProvider = /*#__PURE__*/function () {
  function I18nProvider(maps, _lang, fallback) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, I18nProvider);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "maps", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "_lang", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "fallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "subs", new Set());

    this.maps = maps;
    this._lang = _lang;
    this.fallback = fallback;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(I18nProvider, [{
    key: "lang",
    get: function get() {
      return this._lang;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      if (this._lang === lang) return;
      this._lang = lang;
      this.subs.forEach(function (x) {
        return x(lang);
      });
    }
  }, {
    key: "addSub",
    value: function addSub(cb) {
      this.subs.add(cb);
    }
  }, {
    key: "removeSub",
    value: function removeSub(cb) {
      this.subs.delete(cb);
    }
  }, {
    key: "t",
    get: function get() {
      return this.maps[this.lang] || this.maps[this.fallback];
    }
  }]);

  return I18nProvider;
}();
var provider = new I18nProvider({
  'en-US': {
    verify: {
      password: 'Current user password confirmation',
      expireAfter: 'Do not verify again during this time',
      minute: 'min',
      hour: 'h',
      pwdPlaceholder: 'User Password'
    }
  },
  'zh-CHT': {
    verify: {
      password: "\u7576\u524D\u7528\u6236\u5BC6\u78BC\u78BA\u8A8D",
      expireAfter: "\u5728\u6B64\u6642\u9593\u5167\u4E0D\u518D\u9A57\u8B49",
      minute: "\u5206\u9418",
      hour: "\u5C0F\u6642",
      pwdPlaceholder: "\u8ACB\u8F38\u5165\u7528\u6236\u5BC6\u78BC..."
    }
  },
  'zh-CN': {
    verify: {
      password: "\u5F53\u524D\u7528\u6237\u5BC6\u7801\u786E\u8BA4",
      expireAfter: "\u5728\u6B64\u65F6\u95F4\u5185\u4E0D\u518D\u9A8C\u8BC1",
      minute: "\u5206\u949F",
      hour: "\u5C0F\u65F6",
      pwdPlaceholder: "\u8BF7\u8F93\u5165\u7528\u6237\u5BC6\u7801..."
    }
  }
}, globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN', globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN');
/* harmony default export */ __webpack_exports__["default"] = (provider);

/***/ }),

/***/ "./src/store/constants.ts":
/*!********************************!*\
  !*** ./src/store/constants.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Getters": function() { return /* binding */ Getters; },
/* harmony export */   "Mutations": function() { return /* binding */ Mutations; }
/* harmony export */ });
var Getters;

(function (Getters) {
  Getters["Status"] = "Status";
  Getters["Callback"] = "Callback";
  Getters["ExpireTime"] = "ExpireTime";
  Getters["Token"] = "Token";
})(Getters || (Getters = {}));

var Mutations;

(function (Mutations) {
  Mutations["Status"] = "Status";
  Mutations["Callback"] = "Callback";
  Mutations["ExpireTime"] = "ExpireTime";
  Mutations["Token"] = "Token";
})(Mutations || (Mutations = {}));

/***/ }),

/***/ "./src/store/getters.ts":
/*!******************************!*\
  !*** ./src/store/getters.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "genGetters": function() { return /* binding */ genGetters; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constants */ "./src/store/constants.ts");


function genGetters() {
  var _getters;

  var getters = (_getters = {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_getters, _constants__WEBPACK_IMPORTED_MODULE_1__.Getters.Callback, function (store) {
    return store.callback;
  }), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_getters, _constants__WEBPACK_IMPORTED_MODULE_1__.Getters.Status, function (store) {
    return store.status;
  }), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_getters, _constants__WEBPACK_IMPORTED_MODULE_1__.Getters.ExpireTime, function (store) {
    return store.expireTime;
  }), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_getters, _constants__WEBPACK_IMPORTED_MODULE_1__.Getters.Token, function (store) {
    return store.token;
  }), _getters);
  return getters;
}

/***/ }),

/***/ "./src/store/index.ts":
/*!****************************!*\
  !*** ./src/store/index.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "moduleName": function() { return /* binding */ moduleName; },
/* harmony export */   "ns": function() { return /* binding */ ns; },
/* harmony export */   "nsHelper": function() { return /* binding */ nsHelper; },
/* harmony export */   "VerifierGetter": function() { return /* binding */ VerifierGetter; },
/* harmony export */   "VerifierMutation": function() { return /* binding */ VerifierMutation; },
/* harmony export */   "Getters": function() { return /* reexport safe */ _constants__WEBPACK_IMPORTED_MODULE_4__.Getters; },
/* harmony export */   "Mutations": function() { return /* reexport safe */ _constants__WEBPACK_IMPORTED_MODULE_4__.Mutations; },
/* harmony export */   "factory": function() { return /* binding */ factory; }
/* harmony export */ });
/* harmony import */ var _getters__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getters */ "./src/store/getters.ts");
/* harmony import */ var _mutations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mutations */ "./src/store/mutations.ts");
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! vuex */ "vuex");
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vuex_class__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! vuex-class */ "vuex-class");
/* harmony import */ var vuex_class__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vuex_class__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./constants */ "./src/store/constants.ts");




var moduleName = 'verifier';
var ns = (0,vuex_class__WEBPACK_IMPORTED_MODULE_3__.namespace)(moduleName);
var nsHelper = (0,vuex__WEBPACK_IMPORTED_MODULE_2__.createNamespacedHelpers)(moduleName);
var VerifierGetter = ns.Getter;
var VerifierMutation = ns.Mutation;

var initialStore = {
  callback: undefined,
  status: false,
  expireTime: undefined,
  token: undefined
};
function factory(store, router) {
  store.registerModule(moduleName, {
    namespaced: true,
    state: initialStore,
    getters: (0,_getters__WEBPACK_IMPORTED_MODULE_0__.genGetters)(),
    mutations: (0,_mutations__WEBPACK_IMPORTED_MODULE_1__.genMutations)()
  });
}

/***/ }),

/***/ "./src/store/mutations.ts":
/*!********************************!*\
  !*** ./src/store/mutations.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "genMutations": function() { return /* binding */ genMutations; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constants */ "./src/store/constants.ts");


function genMutations() {
  var _mutations;

  var mutations = (_mutations = {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.Callback, function (store, value) {
    store.callback = value;
  }), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.Status, function (store, value) {
    store.status = value;
  }), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.ExpireTime, function (store, value) {
    store.expireTime = value;
  }), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_mutations, _constants__WEBPACK_IMPORTED_MODULE_1__.Mutations.Token, function (store, value) {
    store.token = value;
  }), _mutations);
  return mutations;
}

/***/ }),

/***/ "./src/verifier.tsx":
/*!**************************!*\
  !*** ./src/verifier.tsx ***!
  \**************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! core-js/modules/es.object.entries.js */ "core-js/modules/es.object.entries.js");
/* harmony import */ var core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_form__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/form */ "@splat/form");
/* harmony import */ var _splat_form__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_form__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _splat_form_item__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @splat/form-item */ "@splat/form-item");
/* harmony import */ var _splat_form_item__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_splat_form_item__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _splat_iconfont__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @splat/iconfont */ "@splat/iconfont");
/* harmony import */ var _splat_iconfont__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_splat_iconfont__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @splat/input */ "@splat/input");
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_splat_input__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _splat_select__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @splat/select */ "@splat/select");
/* harmony import */ var _splat_select__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_splat_select__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _gen__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./gen */ "./src/gen/index.ts");
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./locales */ "./src/locales/index.ts");
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./store */ "./src/store/index.ts");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! moment */ "moment");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_19__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};













var Verifier = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(Verifier, _tsx$Component);

  var _super = _createSuper(Verifier);

  function Verifier() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, Verifier);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "client", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "updateCallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "updateStatus", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "updateExpireTime", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "updateToken", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "verify", {
      password: '',
      expireAfter: 10
    });

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18n", _locales__WEBPACK_IMPORTED_MODULE_15__["default"]);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nInjection", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nProvider", _this.i18n);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(Verifier, [{
    key: "render",
    value: function render() {
      var h = arguments[0];
      var verify = this.verify,
          i18n = this.i18n;
      return h((_splat_form__WEBPACK_IMPORTED_MODULE_9___default()), {
        "ref": 'verifyForm',
        "attrs": {
          "formModel": verify,
          "labels": {
            password: i18n.t.verify.password,
            expireAfter: i18n.t.verify.expireAfter
          }
        }
      }, [h((_splat_form_item__WEBPACK_IMPORTED_MODULE_10___default()), {
        "attrs": {
          "prop": 'password',
          "required": true
        }
      }, [h((_splat_input__WEBPACK_IMPORTED_MODULE_12___default()), {
        "attrs": {
          "placeholder": i18n.t.verify.pwdPlaceholder,
          "type": 'password',
          "value": verify.password
        },
        "on": {
          "input": function input(v) {
            return verify.password = v;
          }
        }
      })]), h((_splat_form_item__WEBPACK_IMPORTED_MODULE_10___default()), {
        "attrs": {
          "prop": 'expireAfter'
        }
      }, [h((_splat_select__WEBPACK_IMPORTED_MODULE_13___default()), {
        "attrs": {
          "multiple": false,
          "value": verify.expireAfter,
          "options": [{
            label: "5".concat(i18n.t.verify.minute),
            value: 5
          }, {
            label: "10".concat(i18n.t.verify.minute),
            value: 10
          }, {
            label: "30".concat(i18n.t.verify.minute),
            value: 30
          }, {
            label: "1".concat(i18n.t.verify.hour),
            value: 60
          }, {
            label: "8".concat(i18n.t.verify.hour),
            value: 60 * 8
          }]
        },
        "on": {
          "input": function input(v) {
            return verify.expireAfter = v;
          }
        }
      })])]);
    }
  }, {
    key: "verfiyCallback",
    value: function verfiyCallback() {
      var _this2 = this;

      if (this.$refs.verifyForm.validateAll()) {
        var expireWithLease = moment__WEBPACK_IMPORTED_MODULE_17___default()().add(this.verify.expireAfter - 1, 'minutes');
        return (0,_gen__WEBPACK_IMPORTED_MODULE_14__.AccountAuthServiceCreateSessionTokenCall)(this.client, {
          type: 'pwd',
          credentials: {
            password: this.verify.password
          },
          duration: this.verify.expireAfter * 60,
          permissions: ['privileged']
        }).then(function (reply) {
          _this2.updateToken(reply.result.token);

          _this2.updateStatus(true);

          _this2.updateExpireTime(expireWithLease.toDate());

          sessionStorage.setItem('Session-Token', reply.result.token);
        });
      }

      return Promise.reject();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this3 = this;

      if (this.i18nInjection) {
        this.i18nInjection.addSub(this.updateLang);
        this.i18n.setLanguage(this.i18nInjection.lang);
      }

      this.updateCallback(this.verfiyCallback.bind(this));
      var token = sessionStorage.getItem('Session-Token');

      if (token) {
        (0,_gen__WEBPACK_IMPORTED_MODULE_14__.AccountAuthServiceGetSessionTokenExpireCall)(this.client, undefined, undefined, {
          'Session-Token': token
        }).then(function (reply) {
          if (reply.result.valid) {
            _this3.updateStatus(true);

            _this3.updateExpireTime(moment__WEBPACK_IMPORTED_MODULE_17___default().unix(reply.result.expire_time).toDate());

            _this3.updateToken(token);
          } else {
            sessionStorage.removeItem('Session-Token');

            _this3.updateStatus(false);

            _this3.updateExpireTime(undefined);
          }
        });
      }
    }
  }, {
    key: "updateLang",
    value: function updateLang(l) {
      this.i18n.setLanguage(l);
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.i18nInjection) {
        this.i18nInjection.removeSub(this.updateLang);
      }

      this.updateCallback(undefined);
    }
  }]);

  return Verifier;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_19__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)()], Verifier.prototype, "client", void 0);

__decorate([(0,_store__WEBPACK_IMPORTED_MODULE_16__.VerifierMutation)(_store__WEBPACK_IMPORTED_MODULE_16__.Mutations.Callback)], Verifier.prototype, "updateCallback", void 0);

__decorate([(0,_store__WEBPACK_IMPORTED_MODULE_16__.VerifierMutation)(_store__WEBPACK_IMPORTED_MODULE_16__.Mutations.Status)], Verifier.prototype, "updateStatus", void 0);

__decorate([(0,_store__WEBPACK_IMPORTED_MODULE_16__.VerifierMutation)(_store__WEBPACK_IMPORTED_MODULE_16__.Mutations.ExpireTime)], Verifier.prototype, "updateExpireTime", void 0);

__decorate([(0,_store__WEBPACK_IMPORTED_MODULE_16__.VerifierMutation)(_store__WEBPACK_IMPORTED_MODULE_16__.Mutations.Token)], Verifier.prototype, "updateToken", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Inject)({
  from: 'i18nInjection',
  default: null
})], Verifier.prototype, "i18nInjection", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Provide)('i18nInjection')], Verifier.prototype, "i18nProvider", void 0);

Verifier = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Component], Verifier);
/* harmony default export */ __webpack_exports__["default"] = (Verifier);

/***/ }),

/***/ "core-js/modules/es.object.entries.js":
/*!*******************************************************!*\
  !*** external "core-js/modules/es.object.entries.js" ***!
  \*******************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_es_object_entries_js__;

/***/ }),

/***/ "core-js/modules/esnext.global-this.js":
/*!********************************************************!*\
  !*** external "core-js/modules/esnext.global-this.js" ***!
  \********************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__;

/***/ }),

/***/ "@splat/form":
/*!*********************************************************************!*\
  !*** external {"commonjs":"@splat/form","commonjs2":"@splat/form"} ***!
  \*********************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_form__;

/***/ }),

/***/ "@splat/form-item":
/*!*******************************************************************************!*\
  !*** external {"commonjs":"@splat/form-item","commonjs2":"@splat/form-item"} ***!
  \*******************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_form_item__;

/***/ }),

/***/ "@splat/iconfont":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/iconfont","commonjs2":"@splat/iconfont"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_iconfont__;

/***/ }),

/***/ "@splat/input":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/input","commonjs2":"@splat/input"} ***!
  \***********************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_input__;

/***/ }),

/***/ "@splat/select":
/*!*************************************************************************!*\
  !*** external {"commonjs":"@splat/select","commonjs2":"@splat/select"} ***!
  \*************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_select__;

/***/ }),

/***/ "moment":
/*!***********************************************************!*\
  !*** external {"commonjs":"moment","commonjs2":"moment"} ***!
  \***********************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_moment__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "vuex":
/*!*******************************************************!*\
  !*** external {"commonjs":"vuex","commonjs2":"vuex"} ***!
  \*******************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vuex__;

/***/ }),

/***/ "vuex-class":
/*!*******************************************************************!*\
  !*** external {"commonjs":"vuex-class","commonjs2":"vuex-class"} ***!
  \*******************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vuex_class__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Getters": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_1__.Getters; },
/* harmony export */   "Mutations": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_1__.Mutations; },
/* harmony export */   "VerifierGetter": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_1__.VerifierGetter; },
/* harmony export */   "VerifierMutation": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_1__.VerifierMutation; },
/* harmony export */   "factory": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_1__.factory; },
/* harmony export */   "moduleName": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_1__.moduleName; },
/* harmony export */   "ns": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_1__.ns; },
/* harmony export */   "nsHelper": function() { return /* reexport safe */ _store__WEBPACK_IMPORTED_MODULE_1__.nsHelper; }
/* harmony export */ });
/* harmony import */ var _verifier__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./verifier */ "./src/verifier.tsx");
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./store */ "./src/store/index.ts");


/* harmony default export */ __webpack_exports__["default"] = (_verifier__WEBPACK_IMPORTED_MODULE_0__["default"]);
}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map